import { AssistantLaunchRecord } from '../../../shared/models/revenue/AssistantLaunchReport';

export const uniqueLiveLocations = (records: AssistantLaunchRecord[]) => {
    const seen = new Set<string>();
    return records.filter(record => {
        const key = record.applicationId || record.id;
        if (!key) return true;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
};
